import axios from "axios";
import { qClient } from "../../../../index";

export type TeamType = { name: string; slug: string };
export type RegionType = { name: string; ru_code: number };
export type CamouflagesType = { name: string; image: string };

export type DataType = {
  region_name: string;
  experience: string;
  about: string;
  username: string;
  user_callsign: string;
  user_teams: TeamType[];
  main_spec_name_select: string;
  user_camouflages: { name: string; image: string }[];
  user_armory: any;
  user_banner_link: string;
  user_avatar_link: string;
  experience_select: string;
  team_slug: string;
  user_profile_visibility_selected: "Все" | "Только пользователи" | "Никто";
  user_stats_visibility_selected: "Все" | "Только пользователи" | "Никто";
  teams: any[];
  armoryList: {
    id: string;
    name: string;
    firm_name: string;
    is_profile_weapon: boolean;
  }[];
  armoryListFull: any;
  selectedArmory: any;
  weapon_id: any;
  camouflages: any;
};

const getCookie = (name: string) => {
  const v = `; ${document.cookie}`.split(`; ${name}=`);
  return v.length === 2 ? v.pop()?.split(";").shift() : null;
};
axios.defaults.headers.common["X-CSRFToken"] = getCookie("csrftoken") || "";

const getValue = (label: string) => {
  if (label === "Все") {
    return "all";
  } else {
    if (label === "Только пользователи") {
      return "users_only";
    }
    if (label === "Никто") {
      return "nobody";
    } else {
      return undefined;
    }
  }
};

export default function useUserProfile(username: string) {
  const fetchUserData = () => axios.get(`/user-profile/${username}/edit/`);
  const fetchStatistics = () =>
    axios.get(`/user-profile/${username}/statistics/`);
  const fetchRegions = () => axios.get("/info/regions/").then((r) => r.data);

  const patchUserData = async (
    data: Partial<DataType>,
    teams: { name: string; slug: string }[] | undefined
  ) => {
    const teamEntry = teams?.find((t) => t.name === data.team_slug);
    const team_slug = teamEntry?.slug;
    const request = {
      user_callsign: data.user_callsign,
      username: data.username,
      about: data.about,
      region_name: data.region_name,
      weapon_id: data.weapon_id,
      team_slug: team_slug,
      main_spec_name: data.main_spec_name_select?.[0],
      camouflages: data.camouflages.map((cam: { name: string }) => cam.name),
      user_profile_visibility: getValue(data.user_profile_visibility_selected!),
      user_stats_visibility: getValue(data.user_stats_visibility_selected!),
      //experience: data.experience_select,
    };
    const cleaned = Object.fromEntries(
      Object.entries(request).filter(([, v]) => v !== undefined)
    );
    data.username && localStorage.setItem("username", data.username);
    await axios.patch(`/user-profile/${username}/edit/`, cleaned);
    qClient.invalidateQueries({
      queryKey: ["userProfile", username, "profile"],
    });
  };

  const uploadUserAvatar = (file: File) => {
    axios.put("/user-profile/upload-avatar/", file, {
      headers: { "content-type": "image/jpeg" },
    });
    qClient.invalidateQueries({
      queryKey: ["userProfile", username, "profile"],
    });
  };

  const uploadUserTheme = async (file: File) => {
    await axios.put("/user-profile/upload-banner/", file, {
      headers: { "content-type": "image/jpeg" },
    });
    qClient.invalidateQueries({
      queryKey: ["userProfile", username, "profile"],
    });
  };

  const fetchSpecialisations = async () =>
    await axios.get("/info/specialisations/");

  const fetchCamouflages = async () => await axios.get("/info/camouflages/");

  const fetchArmoryList = async (username: string) =>
    await axios.get(`/user-profile/${username}/armory/`);

  return {
    fetchUserData,
    fetchStatistics,
    fetchRegions,
    patchUserData,
    uploadUserAvatar,
    uploadUserTheme,
    fetchCamouflages,
    fetchSpecialisations,
    fetchArmoryList,
  };
}
